import script from "./UserInfoItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfoItem.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfoItem.vue?vue&type=style&index=0&id=63ab9236&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ab9236"]])

export default __exports__